import { Button } from "@designs-by-maryam/ui/components/button";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/lib/theme";

export function ThemeToggle() {
	const { resolvedTheme, toggleTheme } = useTheme();
	const isDark = resolvedTheme === "dark";

	return (
		<Button
			aria-label={`Switch to ${isDark ? "light" : "dark"} mode`}
			aria-pressed={isDark}
			className="h-9 w-9 rounded-full"
			onClick={toggleTheme}
			role="switch"
			size="icon"
			variant="ghost"
		>
			{isDark ? (
				<Sun className="h-4 w-4 text-yellow-400" />
			) : (
				<Moon className="h-4 w-4 text-slate-700" />
			)}
		</Button>
	);
}
